module.exports = __webpack_public_path__ + "assets/img/cus6.3b44ea15.jpg";